/**
 * User: jv
 * Date: 12/05/16
 * Time: 12:56
 */
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const CONSTANTS = require("Sources/config/constants");
const localeReq = require.context("Localization", true, /\.json$/);

let LanguageManager = {};

((LanguageManager) =>
{
  let locale = null;
  let localeMap = null;

  LanguageManager.init = function()
  {
    locale = localStorage.getItem("locale");

    let tmpLocale = utils.getQueryParam("locale");
    if(!utils.isNullOrEmpty(tmpLocale))
    {
      locale = tmpLocale;
      localStorage.setItem("locale", locale);
    }

    if(utils.isNullOrEmpty(locale) || !localeExists(locale))
    {
      locale = CONSTANTS.DEFAULT_LOCALE;
    }

    $("html").addClass(locale);

    _init();
  };

  function _init()
  {
    getLocaleMap();
    applyLocale();
    $(".page-wrapper").show();

    if(utils.isFunction(LanguageManager.onInit))
    {
      LanguageManager.onInit();
    }

    if(utils.isFunction(LanguageManager.onInitGlobal))
    {
      LanguageManager.onInitGlobal();
    }
  }

  LanguageManager.onInit = null;

  LanguageManager.onInitGlobal = null;

  LanguageManager.changeLocale = function(newLocale)
  {
    if(localeExists(newLocale))
    {
      $("html").removeClass(locale).addClass(newLocale);
      locale = newLocale;
      localStorage.setItem("locale", locale);
      LanguageManager.localize();
    }
    else
    {
      throw "Locale does not exist";
    }
  };

  LanguageManager.getCurrentLocale = function()
  {
    return locale;
  };

  LanguageManager.localize = function()
  {
    if(!localeMapIsDefined() || locale !== localeMap.locale)
    {
      getLocaleMap();
      applyLocale();
    }
    else
    {
      applyLocale();
    }
  };

  function getLocaleMap()
  {
    try
    {
      log.info("Trying to fetch locale '%s'", locale);

      let localeRequire = "./" + locale + ".json";

      log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);

      if($.inArray(localeRequire, localeReq.keys()) !== -1)
      {
        let tmpLocaleMap = localeReq(localeRequire);

        log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);

        localeMap = tmpLocaleMap;
      }
      else if(locale !== "nl-BE" && $.inArray("./nl-BE.json", localeReq.keys()) !== -1)
      {
        $("html").removeClass(locale).addClass("nl-BE");
        locale = "nl-BE";
        localStorage.setItem("locale", locale);
        getLocaleMap(callback);
      }
      else
      {
        log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
        alert("Localisation could not be loaded, contact your site administrator.");
      }
    }
    catch(e)
    {
      console.error(e);
    }
  }

  function localeExists(pLocale)
  {
    let localeRequire = "./" + pLocale + ".json";

    return $.inArray(localeRequire, localeReq.keys()) !== -1;
  }

  LanguageManager.applyLocale = function(selector)
  {
    if(localeMapIsDefined() && locale === localeMap.locale)
    {
      // Add back to include the selector itself
      applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
    }
  };

  function applyLocale($element)
  {
    $element = utils.isNotNull($element) ? $element : $("[data-localize]");

    $element.each(function()
    {
      let element = $(this);
      //let key = $(this).data("localize");
      let key = $(this).attr("data-localize");

      if(typeof localeMap === "object" && localeMap.localization.hasOwnProperty(key))
      {
        applyElementLocalization(element, localeMap.localization[key]);
      }
      else
      {
        applyElementLocalization(element, key);
      }
    });
  }

  function applyElementLocalization(element, text)
  {
    let localizeTo = element.data("localize-to");
    let isFormInput = element.is("input") || element.is("textarea");

    if(isFormInput)
    {
      //element.attr("placeholder", text.toLowerCase());
      element.attr("placeholder", text);
    }

    if(!utils.isNullOrEmpty(localizeTo))
    {
      localizeTo = localizeTo.split(";");

      for(let i = 0; i < localizeTo.length; i++)
      {
        if(localizeTo[i] === "text-node")
        {
          replaceNodeText(element, text);
        }
        else
        {
          element.attr(localizeTo[i], text);
        }
      }
    }
    else if(!isFormInput)
    {
      replaceNodeText(element, text);
    }
  }

  function replaceNodeText(element, text)
  {
    element.html(text);
  }

  LanguageManager.getValueForKey = function(key)
  {
    if(localeMapIsDefined() && localeMap.localization.hasOwnProperty(key))
    {
      return localeMap.localization[key];
    }
    else
    {
      return key;
    }
  };

  function localeMapIsDefined()
  {
    return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
  }
})(LanguageManager);

module.exports = LanguageManager;



// WEBPACK FOOTER //
// ./app/js/services/language-manager.js